import { useEffect, useRef } from 'react';
import styles from './index.module.sass';
import { ReactComponent as IconClose } from 'assets/icon_close.svg';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

const Video = ({ videoId, show, onClose }) => {
  const iframeContainerRef = useRef();
  let iframePlayer = document.createElement('div');
  iframePlayer.id = 'iframe-player';

  useEffect(() => {
    const loadVideo = () => {
      iframeContainerRef.current.appendChild(iframePlayer);

      const onPlayerReady = event => {
        event.target.playVideo();
      };

      new window.YT.Player('iframe-player', {
        height: '100%',
        width: '100%',
        videoId,
        playerVars: {
          autoplay: 1,
          controls: 0,
          rel: 0,
          fs: 0,
          loop: 1,
          modestbranding: 1,
          showinfo: 0,
        },
        events: {
          onReady: onPlayerReady,
        },
      });
    };

    if (show) {
      if (!window.YT) {
        window.onYouTubeIframeAPIReady = loadVideo;
      } else {
        loadVideo();
      }
    } else {
      if (iframeContainerRef.current.childNodes.length > 0) {
        let child = iframeContainerRef.current.firstChild;
        iframeContainerRef.current.removeChild(child);
      }
    }
  }, [show, iframePlayer]); // eslint-disable-line

  const videoClass = cx({
    video: true,
    show,
  });

  return (
    <div className={videoClass}>
      <div
        className={styles.close}
        onClick={e => {
          e.stopPropagation();
          onClose();
        }}
      >
        <IconClose />
      </div>
      <div ref={iframeContainerRef} />
    </div>
  );
};

export default Video;
